import { render, staticRenderFns } from "./AdminIndexesComponent.vue?vue&type=template&id=4eb8739c"
import script from "./AdminIndexesComponent.vue?vue&type=script&lang=js"
export * from "./AdminIndexesComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminIndexesComponent.vue?vue&type=style&index=0&id=4eb8739c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports